import React, {useContext, useMemo} from "react";
import {ARow} from "@cisco-sbg-ui/magna-react";
import {omit} from "lodash-es";
import {IncidentsContext} from "contexts/IncidentsContext";
import {
  ASSIGNMENT_MAP,
  DATE_RANGES_MAP,
  INCIDENT_FILTER_SORT_DEFAULT,
  STATUS_MAP
} from "models/options";
import MetricsCard from "./MetricsCard";
import {useIncidentsCount} from "./useIncidentsCount";
import css from "./MetricsCards.module.scss";

const MetricsCards = () => {
  const {handleMetricsCardSearch, filterSettings} =
    useContext(IncidentsContext);

  const {totalCount, newCount, openCount, unassignedCount} =
    useIncidentsCount();

  const active = [
    ...filterSettings.statusFilter,
    ...filterSettings.assigneeFilter
  ];

  const isCardActive = (name) =>
    active.length === 1 &&
    (filterSettings.statusFilter.includes(name) ||
      filterSettings.assigneeFilter.includes(name));

  const standardFilter = useMemo(
    () => ({
      ...omit(INCIDENT_FILTER_SORT_DEFAULT, "assigneeQuery", "statusQuery"),
      assigneeFilter: INCIDENT_FILTER_SORT_DEFAULT.assigneeFilter,
      dateRangeFilter: {filter: DATE_RANGES_MAP.LASTYEAR.value},
      order: INCIDENT_FILTER_SORT_DEFAULT.order,
      orderBy: INCIDENT_FILTER_SORT_DEFAULT.orderBy
    }),
    []
  );

  const cards = useMemo(
    () => [
      {
        component: (
          <MetricsCard
            i18nKey={"incidents.metrics.allIncidents"}
            count={totalCount}
            handleSearch={handleMetricsCardSearch}
            className={css.cardWidth}
            filters={{...standardFilter}}
            active={active.length === 0}
          />
        )
      },
      {
        component: (
          <MetricsCard
            i18nKey={"incidents.metrics.newIncidents"}
            count={newCount}
            handleSearch={handleMetricsCardSearch}
            className={css.cardWidth}
            filters={{
              ...standardFilter,
              statusFilter: [STATUS_MAP.New.value]
            }}
            active={isCardActive(STATUS_MAP.New.value)}
          />
        )
      },
      {
        component: (
          <MetricsCard
            i18nKey={"incidents.metrics.openIncidents"}
            count={openCount}
            handleSearch={handleMetricsCardSearch}
            className={css.cardWidth}
            filters={{
              ...standardFilter,
              statusFilter: [STATUS_MAP.Open.value]
            }}
            active={isCardActive(STATUS_MAP.Open.value)}
          />
        )
      },
      {
        component: (
          <MetricsCard
            i18nKey={"incidents.metrics.unassignedIncidents"}
            count={unassignedCount}
            handleSearch={handleMetricsCardSearch}
            className={css.cardWidth}
            filters={{
              ...standardFilter,
              assigneeFilter: [ASSIGNMENT_MAP.Unassigned.value]
            }}
            active={isCardActive(ASSIGNMENT_MAP.Unassigned.value)}
          />
        )
      }
    ],
    [
      totalCount,
      newCount,
      openCount,
      unassignedCount,
      isCardActive,
      filterSettings
    ]
  );

  return (
    <ARow
      className="metrics-cards"
      style={{flexWrap: "nowrap"}}
      data-testid={"MetricsCards-Row"}>
      {cards.map((card, i) => (
        <React.Fragment key={`metric-card=${i}`}>
          {card.component}
        </React.Fragment>
      ))}
    </ARow>
  );
};

export default MetricsCards;
